module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshow),
      expression: "isshow"
    }],
    staticClass: "sortview-bg",
    on: {
      "click": _vm.sortBg
    }
  }, [_c('div', {
    staticClass: "sort-menu"
  }, [_c('a', {
    staticClass: "sort-time",
    on: {
      "click": function($event) {
        _vm.sortTime($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("按事件分类")])]), _vm._v(" "), _c('a', {
    staticClass: "sort-tag",
    on: {
      "click": function($event) {
        _vm.sortTag($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tags",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("按标签分类")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb32a750"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sortBgview.vue
// module id = 56
// module chunks = 0